import { Component, HostBinding, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { AssistanceService } from "../../services/assistance/assistance.service";
import { NavigationItem } from "../../services/navigation-item/NavigationItem";
import { NavigationItemService } from "../../services/navigation-item/navigation-item.service";
import { Router } from "@angular/router";
import { CarouselComponent } from "../../components/carousel/carousel.component";
import { MessengerService } from '../../services/messenger/messenger.service';
import { TilesComponent } from "../../components/tiles/tiles.component";
import { LocalStorageService } from '../../services/local-storage/local-storage.service';
import { TranslateService } from '../../services/translate/translate.service';
import { MetaService } from '../../services/meta/meta.service';
import * as _ from 'lodash';
import { HelperService } from '../../services/helper/helper.service';
import { IdleService } from '../../services/idle/idle.service';
import { filter } from 'rxjs/operators';
import { skip } from 'rxjs';

@Component({
  selector: 'page-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
  providers: [LocalStorageService]
})

export class MenuComponent implements OnDestroy, OnInit {

  @ViewChild('widgetCarousel') widgetCarousel: CarouselComponent;
  @ViewChild('appTiles') appTiles: TilesComponent;
  @HostBinding('style.background-image') backgroundImage: string;
  @HostBinding('class.active') active = false;

  id = 'menu';
  date = new Date();
  languages = [];
  language: string;
  horizontal = 5;
  vertical = 3;
  logoLayer;
  noBlurClass = false;
  clockColor = '#FFF';
  logoPosition = 'center';
  showFooter = true;
  isLoading = false;
  selectedPage = 0;
  initCounter = 0;

  languageSelectionOpen = false;
  helpersOpen = false;

  disableHelpers = false;
  enableWheelchairNavigation = false;
  enableHighContrastMode = false;

  magnifyingGlassActive = false;
  barrierFreeModeActive = false;
  highContrastModeActive = false;

  isSearchEnabled = false;
  hasIbexsmart = false;

  public apps: NavigationItem[] | any[] = [];
  public groupedApps: NavigationItem[][] | any[][] = [];
  private subscriptions = [];
  private eventListeners = [];

  constructor(
    private assistance: AssistanceService, private navigationItemService: NavigationItemService, private router: Router,
    private messenger: MessengerService, private translateService: TranslateService, private meta: MetaService, private idle: IdleService
  ) {
    this.subscriptions.push(this.idle.$idle.pipe(skip(1), filter(Boolean)).subscribe(() => { this.closeMenu(); }));
    this.language = this.messenger.currentLanguage;
    this.languages = this.messenger.availableLanguages;
    this.subscriptions.push(this.translateService.$ready.subscribe(ready => {
      this.showFooter = ready;
    }));
    this.backgroundImage = this.meta.$backgroundImage.getValue();
    this.subscriptions.push(this.meta.$changed.subscribe(changed => {
      this.noBlurClass = this.meta.getBoolean('ibexTouch.disableBlurInApp');
      this.clockColor = this.meta.getString('ibexTouch.contentText', this.clockColor);
      this.logoPosition = this.meta.getString('ibexTouch.logoPosition', this.logoPosition);
      this.disableHelpers = this.meta.getBoolean('ibexTouch.disableHelps');
      this.enableWheelchairNavigation = this.meta.getBoolean('ibexTouch.enableWheelchairNavigation');
      this.enableHighContrastMode = this.meta.getBoolean('ibexTouch.enableHighContrastMode');
      this.logoLayer = this.meta.getString('images.logos.screen', this.logoLayer);
      this.isSearchEnabled = this.meta.getBoolean('ibexTouch.isSearchEnabled');
      this.hasIbexsmart = this.meta.getBoolean('ibexApp.enabled');
    }));
    this.subscriptions.push(this.navigationItemService.$ready.subscribe(() => {
      this.addEventListener();
      this.init();
    }));

    this.subscriptions.push(this.messenger.$currentLanguage.subscribe(lang => this.language = lang));

    this.subscriptions.push(this.assistance.$magnifyingGlassActive.subscribe(active => { this.magnifyingGlassActive = active; }));
    this.subscriptions.push(this.assistance.$barrierFreeModeActive.subscribe(active => {
      this.barrierFreeModeActive = active;
      this.init();
    }));
    this.subscriptions.push(this.assistance.$highContrastModeActive.subscribe(active => { this.highContrastModeActive = active; }));
  }

  init() {
    this.language = this.messenger.currentLanguage;
    const contentLang = this.navigationItemService.navigationItems.find(el => el?.entry?.lang)?.entry?.lang || window?.['masterLanguage'] || 'de';
    this.apps = this.navigationItemService.navigationItems.filter((element: any) => !element?.entry?.navigationItem?.widgetOnly && !element?.entry?.detail?.widgetOnly);
    if (this.barrierFreeModeActive)  {
      this.apps = this.addEmptyItems(this.apps, 5, 10, {empty: true});
    }
    const newApps = _.chunk(this.apps, 15);
    if ((newApps?.length > 0 && newApps?.[0]?.length > 0 && this.language === contentLang) || this.initCounter >= 20) {
      this.initCounter = 0;
      this.groupedApps = newApps;
      this.isLoading = false;
      this.active = true;
    } else {
      this.initCounter++;
      setTimeout(() => { this.init() }, 250);
    }
  }

  addEmptyItems(arr, blockSize = 5, insertCount = 10, filler: any) {
    return [
      ...Array(insertCount).fill(filler), ...arr.flatMap((chunk, i, self) => {
        const part = [chunk];
        if ((i + 1) % blockSize === 0 && i !== self.length - 1) {
          part.push(...Array(insertCount).fill(filler));
        }
        return part;
      })
    ];
  }

  addEventListener() {
    const element = document.getElementById('slides-container');
    if (!element) {
      return setTimeout(() => { this.addEventListener() }, 100);
    }
    const callback = () => { this.selectedPage = Math.round(element.scrollLeft / 1500); };
    element.addEventListener('scroll', callback);
    this.eventListeners.push(element, 'scroll', callback);
  }

  async closeMenu() {
    console.warn('closing menu');
    this.active = false;
    await HelperService.wait(500);
    this.router.navigate([{ outlets: { 'overlay': null } }]);
  }

  ngOnDestroy() {
    for (const subscription of this.subscriptions) {
      subscription.unsubscribe();
    }
    this.subscriptions.length = 0;
    this.eventListeners.forEach(listener => {
      listener?.element?.removeEventListener(listener.action, listener.callback);
    });
    this.eventListeners = [];
  }

  ngOnInit() {
    this.language = this.messenger.currentLanguage;
  }

  async openApp(app: any) {
    this.messenger.$currentSearchValue.next('');
    if (app?.entry?.navigationItem?.contentType === 'code-snippet' && !app.entry.navigationItem.live) {
      await this.router.navigate(['home']);
      if (app.entry.navigationItem.overlay) {
        let commands = [app.entry.navigationItem.page, this.navigationItemService.prettifyPath(app.title)];
        await this.router.navigate([{ outlets: { 'overlay': null } }]);
        await this.router.navigate(['home', { outlets: { 'overlay': commands } }]);
      }
    } else {
      if (this.barrierFreeModeActive) {
        return await this.router.navigate(['home', { replaceUrl: true }]).then(() => {
          return this.router.navigateByUrl('home/app/' + this.navigationItemService.prettifyPath(app.title), { replaceUrl: true });
        });
      } else {
        return await this.router.navigateByUrl('home/app/' + this.navigationItemService.prettifyPath(app.title), { replaceUrl: true });
      }
    }
  }

  async updateLanguage(lang) {
    if (lang !== this.messenger.currentLanguage) {
      setTimeout(() => { this.messenger.$changeLanguageFromMenu.next(lang) }, 1000);
      this.apps = null;
      await this.router.navigateByUrl('/', { replaceUrl: true });
      this.active = false;
    }
  }

  openOverlay(route) {
    this.router.navigate([{ outlets: { 'overlay': [route] } }]);
  }

  startHelper(type: string, event: any) {
    event.stopPropagation();
    switch (type) {
      case 'magnifying-glass':
        this.assistance.toggleMagnifyingGlass();
        break;
      case 'wheelchair':
        this.assistance.toggleBarrierFreeMode();
        break;
      case 'contrast':
        this.assistance.toggleHighContrastMode();
        break;
    }
  }
}
